<template>
  <ModalConfirmation
    hasBlur
    :showModal="showModal"
    title="Are you sure you want to deactivate?"
  >
    <template v-slot:body>
      <ParagraphBody>
        Deactivating the password manager for the enterprise
        will sign out and deactivate the password manager from
        all users' devices and will erase all passwords stored in the password manager.
        This action is irreversible only click the button below after your users
        have exported all of the data that they need out of the password manager.
      </ParagraphBody>
      <ParagraphBody>
        Are you sure you want to deactivate Password Manager?
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :isFullWidth="false"
      >
        <Button
          hasNoBackground
          :isDisabled="isDeactivating"
          text="cancel"
          @click="handleCancel"
        />
        <Button
          hasOutline
          :isDisabled="isDeactivating"
          text="confirm deactivation"
          type="error"
          @click="handleConfirm"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>

import {
  Button,
  ButtonGroup,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import { trialFeatures } from 'client/util/Constants/FeatureTrialConstants';
import FeatureTrialsMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';
import Util from 'client/util/Util';

export default {

  name: 'PasswordManagerConfirmDeactivateModal',

  components: {
    Button,
    ButtonGroup,
    ModalConfirmation,
    ParagraphBody,
  },

  mixins: [FeatureTrialsMixin],

  props: {
    showModal: Boolean,
  },

  data() {
    return {
      isDeactivating: false,
    };
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    ...mapActions('PasswordManagerModule', [
      'removePasswordManager',
    ]),

    handleCancel() {
      this.$emit('close');
    },

    async handleConfirm() {
      try {
        this.isDeactivating = true;
        await this.removePasswordManager();
        Util.redirect('#/passwordmanager');
        this.triggerSuccessNotification({ title: 'Deactivated', message: 'Password Manager deactivated!' });
        const { featureCode } = trialFeatures.passwordManagement;
        this.refreshTrialData(featureCode);
      } catch (error) {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'There was a problem deactivating Password Manager. Please try again.',
        });
      } finally {
        this.isDeactivating = false;
        this.$emit('close');
      }
    },
  },

};
</script>
